<template>
  <div
    id="profile-details"
    class="d-none d-md-block"
  >
    <div
      class="d-flex profile-section px-6 pb-4 align-items-center"
    >
      <div
        class="avatar avatar-lg"
        :class="avatarClass"
      >
        {{ getInitials(details) }}
      </div>
      <div class="d-flex flex-column justify-content-center user-info">
        <p
          class="mb-0 strong user-name"
          data-test="profile-name"
        >
          {{ details.firstName }} {{ details.lastName }}
        </p>
        <p class="small mt-1 mb-0">
          {{ details.organisation }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapActions, mapState,
} from 'vuex';
import * as accountTypes from '@/modules/account/store/types';
import * as Sentry from '@sentry/browser';
import Feature from 'vue-feature-toggle';

export default {
  name: 'ProfileDetails',
  components: {
  },
  data() {
    return {
      details: {
        firstName: '',
        lastName: '',
        role: '',
        organisation: '',
        profile: '',
      },
      avatarClass: `avatar-${process.env.VUE_APP_AVATAR_DEFAULT_COLOUR}`,
    };
  },
  computed: {
    ...mapState('account', {
      company: 'companyName',
      first: 'firstName',
      last: 'lastName',
      email: 'email',
      avatarColour: 'avatarColour',
    }),
    ...mapState('account', [
      'email',
    ]),
  },
  methods: {
    ...mapActions('account', [
      accountTypes.FETCH_ACCOUNT,
      accountTypes.UPDATE_AVATAR_COLOUR,
    ]),
    getInitials(user) {
      if (!user) return;
      return user.firstName[0]?.toUpperCase() + user.lastName[0]?.toUpperCase();
    },
    setDetails() {
      this.details.firstName = this.first;
      this.details.lastName = this.last;
      this.details.organisation = this.company;
    },
    setFeatures(features) {
      Object.values(features)
        .forEach((feature) => {
          Feature.visibility(feature, true);
        });
    },
    setAvatarColour() {
      const randomColour = process.env.VUE_APP_AVATAR_COLOURS.split(',')
        .map((value) => ({ value: value.trim(), sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .pop().value;
      this.avatarClass = `avatar-${randomColour}`;
      this.UPDATE_AVATAR_COLOUR(randomColour);
    },
  },
  mounted() {
    if (this.first !== null) {
      this.setDetails();
    }
  },
  async created() {
    let account;
    if (this.first === null) {
      account = await this.FETCH_ACCOUNT();
      if (account.companyName === null) this.$router.push('/on-boarding');
      this.setDetails();
      const { features } = account;
      if ((typeof features !== 'undefined') && features.length > 0) this.setFeatures(features);
      this.$emit('setIsLoading', false);
    } else {
      this.$emit('setIsLoading', false);
    }
    if (!this.avatarColour) {
      account = account || await this.FETCH_ACCOUNT();
      if (!account.properties?.avatarColour) {
        this.setAvatarColour();
      }
    }
    if (process.env.NODE_ENV === 'production' && this.email !== null) {
      Sentry.configureScope((scope) => {
        scope.setUser({ email: this.email });
      });
    }
    if (this.avatarColour) this.avatarClass = `avatar-${this.avatarColour}`;
  },
};
</script>
